<template>
  <div class="row">
    <div class="col-sm-12 col-md-6">
        <!-- <TradingChart v-if="$store.state.theme" />
        <TradingChartDark v-else /> -->
        <KlineChart v-if="selectedBi" :bi="selectedBi" ref="chart" />
      </div>
      <div class="col-md-3">
        <MarketTrade
          v-if="selectedBi"
          :biList="biList"
          :bi="selectedBi"
          ref="trade"
        />
      </div>
      <div  class="modal" id="myModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Special Welcome Bonus - Up to 50% on First Deposit</h5>
              <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"></button> -->
            </div>
            <div class="modal-body">
              We are currently running a special promotion offering new users a welcome bonus of up to 50% on their first
              deposit. Single deposits under 50k will receive a 20% welcome bonus, deposits between 50k and 100k will
              receive a 30% welcome bonus, and single deposits over 100k will receive a 50% welcome bonus. This bonus can
              be used for trading and earning profits, presenting an excellent opportunity to enhance your account's
              trading capacity.
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
import KlineChart from "@/components/klinechart.vue";
import MarketTrade from "@/components/MarketTrade.vue";
import {Modal} from 'bootstrap';
export default {
  components: {
    KlineChart,
    MarketTrade,
  },
  computed: {
    biList() {
      return this.$store.state.biList;
    },
    selectedBi() {
      return this.$store.state.selectedBi;
    },
  },
  mounted() {
    //let myModal = new Modal(document.getElementById('myModal'));
    //myModal.show();
  },
};
</script>

<style>

</style>
